<template>
    <div class="contact-list">
        <div class="cantact_hd fix">
            <div class="f-fl">
                <button type="button" class="btn btn-default add_contact_btn" @click="editItem()">
                    <span class="contact-add-icon" aria-hidden="true"></span> 新增联系人/乘客
                </button>
            </div>
            <div class="f-fl" style="margin-left: 5px">
              <privacy-button @privacy-switch="handlePrivacySwitch"></privacy-button>
            </div>
            <div class="f-fr">
                <div class="input-group">
                    <input v-model="searchKeyword" type="text" class="form-control" placeholder="请输入姓名">
                    <span class="input-group-btn">
                        <button class="btn btn-default contact-search-button" type="button" aria-label="Search" @click="searchContact"></button>
                    </span>
                </div>
            </div>
        </div>
        <div class="contact_bd">
            <table class="table">
                <tbody>
                    <tr>
                        <th>姓名</th>
                        <th>性别</th>
                        <th>出生日期</th>
                        <th>手机号</th>
                        <th>护照号</th>
                        <th>会员号</th>
                        <th></th>
                        <th></th>
                    </tr>
                    <tr v-for="item in showList" :key="item.id">
                        <td><template v-if="item.chineseLastName || item.chineseFirstName">{{(item.chineseLastName || '') + (item.chineseFirstName || '')}}<br></template>{{item.pinyinLastName + item.pinyinFirstName}}</td>
                        <td>{{item.gender === 'M' ? '男' : (item.gender === 'F' ? '女' : '未知')}}</td>
                        <td>{{item.dateOfBirth}}</td>
                        <td>{{item.telephone}}</td>
                        <td>{{item.passportNum}}</td>
                        <td></td>
                        <td class="contact_checkbox" v-bind:class="{cur: item.isDefaultContact}">
                            <i class="check_box default_contact" @click="setDefault(item)"></i>
                            <span class="userContact">默认联系人</span>
                        </td>
                        <td class="text_link">
                            <div class="edit_btn" @click="editItem(item)">
                                <i class="detail_ico_18 edit_ico"></i>编辑
                            </div>
                            <div class="delete_btn" @click="deleteItem(item)">
                                <i class="detail_ico_18 delete_ico"></i>删除
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="pagination-box">
            <pagination
                :size="pageSize"
                :total="total"
                :current="pageIndex"
                placement="left"
                @on-change="onPaginationChange"
            ></pagination>
        </div>

        <!-- 创建联系人 -->
        <contact-edit ref="edit" @on-change="handleChange"></contact-edit>
    </div>
</template>

<script>
    import api from '@/api'
    import ContactEdit from './ContactEdit'
    import Pagination from './Pagination'
    import PrivacyButton from "../Common/PrivacyButton";

    export default {
        name: 'ContactList',
        components: {
            ContactEdit,
            Pagination,
            PrivacyButton
        },
        data: () => {
            return {
                token: '',
                preContactList: [],
                contactList: [],
                checkedItem: {},
                pageSize: 10,
                pageIndex: 1,
                total: 0,
                showList: [],
                searchKeyword: ''
            }
        },
        beforeMount () {
            this.init()
        },
        methods: {
            async init () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.token = this.$store.state.user.userToken
                await this.refreshData()
            },
            async refreshData () {
                const data = await this.getContact(this.token)
                this.preContactList = data.filter(item => item.id !== 0) //过滤掉id=0

                this.contactList = this.preContactList
                this.total = this.contactList.length
                this.showList = this.getPageList(this.contactList, this.pageIndex)
            },
            async setDefault (item) {
                const isDefault = item.isDefaultContact
                this.$loading.show()
                const { errMsg, success } = await api.user.setDefaultContact({
                    userContact: {
                        userName: this.token,
                        id: item.id,
                    },
                    isCleanDefault: isDefault
                })
                if (success) {
                    await this.refreshData()
                    this.$loading.hide()
                } else {
                    console.log(errMsg)
                }
            },
            editItem (item) {
                if (item) {
                    this.$refs['edit'].show(item)
                } else {
                    this.$refs['edit'].show()
                }
            },
            onPaginationChange (page) {
                this.pageIndex = page
                this.showList = this.getPageList(this.contactList, this.pageIndex)
            },
            searchContact () {
                this.pageIndex = 1
                this.contactList = this.searchByKey(this.searchKeyword)
                this.total = this.contactList.length
                this.showList = this.getPageList(this.contactList, 1)
            },
            searchByKey (key) {
                const keyWords = key.trim()
                if (keyWords === '') return this.preContactList

                const result = []
                const regExp = new RegExp(`${keyWords}`, 'i')
                this.preContactList.map(item => {
                    if (regExp.test(item.chineseLastName + item.chineseFirstName)) {
                        result.push(item)
                    } else if (regExp.test(item.pinyinLastName + item.pinyinFirstName)) {
                        result.push(item)
                    }
                })
                return result
            },
            getPageList (data, index) {
                return data.slice(this.pageSize * (index - 1), this.pageSize * index)
            },
            async handleChange () {
                this.$loading.show()
                await this.refreshData()
                this.$loading.hide()
            },
            async deleteItem (item) {
                const that = this
                this.$confirm.show('确认删除该联系人吗？', {
                    confirmCallBack: async () => {
                        that.$loading.show()
                        const { errMsg, success } = await api.user.deleteContact({
                            userName: that.token,
                            id: item.id,
                        })
                        if (success) {
                            await that.refreshData()
                            that.$loading.hide()
                        } else {
                            console.log(errMsg)
                        }
                    },
                    cancelCallBack: () => {
                        console.log('取消删除')
                    }
                })
            },
            async getContact (token) {
                const { errMsg, data, success } = await api.user.getContactInPersonalCenter(token)
                if (success) {
                    return data
                } else {
                    console.log(errMsg)
                    return []
                }
            },
            handlePrivacySwitch() {
              this.init();
            }
        }
    }
</script>

<style lang="less" scoped>
    .cantact_hd {
        margin-bottom: 30px;
        .add_contact_btn {
            width: 154px;
            height: 36px;
            background-color: #fbc500;
            line-height: 36px;
            padding: 0;
            border: none;
            outline: none;
            border-radius: 0;
            color: #282b2c;
        }
        .contact-add-icon {
            position: relative;
            top: 2px;
            display: inline-block;
            width: 13px;
            height: 13px;
            margin-right: 4px;
        }
        .contact-add-icon::before,
        .contact-add-icon::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            background: currentColor;
            transform: translate(-50%, -50%);
        }
        .contact-add-icon::before {
            width: 13px;
            height: 2px;
        }
        .contact-add-icon::after {
            width: 2px;
            height: 13px;
        }
        .f-fr {
            width: 277px;
        }
        .input-group {
            background-color: #ffffff;
            border: solid 1px #d3dadd;
            input.form-control, button.contact-search-button {
                border: none;
                background: none;
                border-radius: 0;
                height: 36px;
                line-height: 36px;
                font-style: normal;
            }
            button.contact-search-button {
                position: relative;
                padding: 0;
                width: 44px;
                margin: 0;
                box-shadow: none;
                outline:none;
                color: #818181;
                font-size: 21px;
                font-weight: normal;
            }
            button.contact-search-button::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 13px;
                height: 13px;
                border: 2px solid currentColor;
                border-radius: 50%;
                transform: translate(-60%, -60%);
            }
            button.contact-search-button::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 9px;
                height: 2px;
                background: currentColor;
                border-radius: 2px;
                transform: translate(10%, 90%) rotate(45deg);
            }
        }
    }
    .contact_bd {
        background: #fff;
        min-height: 500px;
        border: solid 1px #d3dadd;
        position:relative;
        .table {
            tbody {
                tr {
                    &:first-child {
                        background-color: #eff2f5;
                        th {
                            vertical-align: middle;
                            padding: 12px 20px;
                            border-top: 0;
                            color: #282b2c;
                        }
                    }
                    td {
                        vertical-align: middle;
                        padding: 16px 20px;
                        color: #282b2c;
                        line-height: 1.6;
                        max-width: 200px;
                    }
                }
                .contact_checkbox {
                    .check_box {
                        width: 18px;
                        height: 18px;
                        border: 1px solid #d3dadd;
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 10px;
                        cursor: pointer;
                    }
                    span {
                        color: #999;
                        font-weight: 400;
                    }
                    &.cur {
                        .check_box {
                            background: url(../../assets/icon-checkBox-checked.png) no-repeat center;
                            border-color: #006ab9;
                        }
                        span {
                            color: #0073bb;
                        }
                    }
                }
                .edit_btn {
                    margin-bottom: 6px;
                    cursor: pointer;
                }
                .delete_btn {
                    cursor: pointer;
                }
                .detail_ico_18 {
                    margin: 0 10px 0 0;
                }
            }
        }
    }
    .pagination-box {
        padding: 20px 0;
    }
</style>
